import { Component, Input, OnInit } from '@angular/core';
import { ActionFormBase } from '../form-action';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-action-dropdown',
    templateUrl: './action-dropdown.component.html',
    styleUrls: ['./action-dropdown.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class ActionDropdownComponent extends ActionFormBase<any> implements OnInit {

  @Input() icon = 'design_bullet-list-67';
  @Input() actionClass = '';
  @Input() showBadge: boolean = false;
  @Input() badgeCount: number = 0;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
